import React, { Component } from 'react';
import ToolbarMixButtons from 'components/toolbar/ToolbarMixButtons.js';

class ArrangementDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Go to the <b>Arrangement View</b> by clicking on the views dropdown
                at the top right of the page, and selecting “Arranger”.
              </p>
              <p>
                You can arrange your patterns into a complete arrangement here. You
                can drag patterns from the pattern boxes at the top toolbar
                into the arrangement timeline. You can then drag the start and
                end points of each pattern to where you want the pattern changes to occur.
              </p>
              <p>
                Furthermore, you can record a mix and have the arrangement be
                automatically recorded. You can do this by clicking on the circle button, to the right
                of the play button at the top toolbar.
                <div>
                  <ToolbarMixButtons sequencerEngine={this.props.sequencerEngine}/>
                </div>
                <div className="clear-fix"/>
              </p>
              <p>
                Note, this is different from the “Record” button at the
                bottom of the sequencer screen (that is only concerned with recording
                triggers into a given pattern).
              </p>
            </div>
        );
    }
}

export default ArrangementDocumentation;
